var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPersonChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0E0E0E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M16 16a6.667 6.667 0 1 0 0-13.333A6.667 6.667 0 0 0 16 16M4.547 29.333C4.547 24.173 9.68 20 16 20c1.28 0 2.52.173 3.68.493"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0E0E0E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M29.333 24c0 1-.28 1.947-.773 2.747A4.8 4.8 0 0 1 27.507 28 5.2 5.2 0 0 1 24 29.333a5.29 5.29 0 0 1-4.56-2.586A5.23 5.23 0 0 1 18.667 24c0-1.68.773-3.187 2-4.16A5.332 5.332 0 0 1 29.334 24"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#292D32",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m21.92 24 1.32 1.32 2.84-2.627"
})));
export default SvgPersonChecked;